// Period closeout picker + the Final view's period status strip. The picker
// lists the program's CONTRACT periods (periods of performance) plus Final;
// team cycles have no browser surface and are never listed.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraSegmentedControl } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Check } from 'lucide-react';
export function periodCloseoutStatus(periodId, checklists) {
    const c = checklists.find((x)=>x.periodId === periodId);
    if (!c) return 'not-started';
    return c.closedAt ? 'closed' : 'in-progress';
}
const STATUS_LABEL = {
    'not-started': 'Not started',
    'in-progress': 'In progress',
    closed: 'Closed'
};
export function periodLabel(p) {
    return p.periodName || 'Unnamed period';
}
/** True when today (UTC) is on or after the period's stated end date. */ export function periodHasEnded(p, now = new Date()) {
    if (!p.endDate) return false;
    const end = p.endDate.toDate().toISOString().slice(0, 10);
    return now.toISOString().slice(0, 10) >= end;
}
export function CloseoutPeriodPicker({ periods, checklists, selectedPeriodId, onSelect }) {
    const options = [
        ...periods.map((p)=>({
                value: p.id,
                label: periodCloseoutStatus(p.id, checklists) === 'closed' ? `${periodLabel(p)} ✓` : periodLabel(p),
                testId: Testids.closeout.periodPickerOption
            })),
        {
            value: '',
            label: 'Final',
            testId: Testids.closeout.periodPickerOption
        }
    ];
    return /*#__PURE__*/ _jsx(SpecraSegmentedControl, {
        label: "Closeout scope",
        size: "sm",
        value: selectedPeriodId,
        onValueChange: onSelect,
        options: options,
        testId: Testids.closeout.periodPicker
    });
}
/**
 * "All periods closed: Base ✓ OP1 ✓ …" on the Final closeout. Display only:
 * closing the program does not require it.
 */ export function AllPeriodsStatus({ periods, checklists }) {
    if (periods.length === 0) return null;
    const statuses = periods.map((p)=>({
            p,
            status: periodCloseoutStatus(p.id, checklists)
        }));
    const allClosed = statuses.every((s)=>s.status === 'closed');
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-wrap items-center gap-2 text-sm",
        "data-testid": Testids.closeout.allPeriodsStatus,
        "data-all-closed": allClosed,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "text-muted-foreground",
                children: allClosed ? 'All periods closed:' : 'Period closeouts:'
            }),
            statuses.map(({ p, status })=>/*#__PURE__*/ _jsxs(SpecraBadge, {
                    variant: status === 'closed' ? 'success' : 'outline',
                    "data-period-id": p.id,
                    "data-status": status,
                    children: [
                        status === 'closed' && /*#__PURE__*/ _jsx(Check, {
                            className: "h-3 w-3"
                        }),
                        periodLabel(p),
                        status !== 'closed' && ` · ${STATUS_LABEL[status]}`
                    ]
                }, p.id))
        ]
    });
}
